import moment from 'moment'

export default value => {
  let birthday = moment(value)
  return Math.abs(birthday.diff(moment(), 'years'))
}
